import { Pipe, PipeTransform } from '@angular/core';
import { ContinentStationZone, Station } from '@models/responses/station-response.model';

@Pipe({
  name: 'continentStationZone',
  standalone: true
})
export class ContinentStationZonePipe implements PipeTransform {

  transform(value: Station[]): ContinentStationZone[] | undefined {
    return value.map((s) => s.locationDetails.continentZoneCode)
    .filter((v, i, c) => c.indexOf(v) === i)
    .map((g) => ({
      zoneCode: g,
      zoneCodeName: value?.find(
        (s) => s.locationDetails.continentZoneCode === g,
      )?.locationDetails.continentZoneCodeName,
      stations: value
        ?.filter((s) => s.locationDetails.continentZoneCode === g)
        .sort((a, b) =>
          a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0,
        ),
    }))
    .sort((a, b) =>
      a.zoneCode > b.zoneCode ? 1 : a.zoneCode < b.zoneCode ? -1 : 0,
    );;
  }

}
